import { Trash2Icon, X } from "lucide-react";
import React, { useState, useRef, useEffect } from "react";
import { FaTrash } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import Sidebar from "../../components/Sidebar";


function Testimoni() {

  const navigate = useNavigate();
  const [testimoni, setTestimoni] = useState([]);
  const [addTestimoni, setAddTestimoni] = useState(null);
  const [editId, setEditId] = useState(null);
  
  const [formDataTestimoni, setFormDataTestimoni] = useState({ nama: '', sumber: '' , komentar: '' , image:''});

  const handleAdd = (event) => {
    setAddTestimoni(event);
    setFormDataTestimoni({ nama: event.nama, sumber: event.sumber, image:event.image, komentar:event.komentar  });
  };


  const fetchTestimoni = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/testimoni`);

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const note = await res.json();
      const list = Array.isArray(note) ? note : note.data || [];

      setTestimoni(list);
    } catch (err) {
      console.error("Gagal mengambil data:", err);
    }
  };
  
  useEffect(() => {
    fetchTestimoni();
  }, []);

  const handleEditClick = (item) => {
    setEditId(item.id);

    setFormDataTestimoni({
      nama: item.nama,
      sumber: item.sumber,
      komentar: item.komentar,
      image: null, // kosongkan dulu file upload
    });

    setAddTestimoni(true); // buka modal
  };

  const handleInsert = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("nama", formDataTestimoni.nama);
      formData.append("sumber", formDataTestimoni.sumber);
      formData.append("komentar", formDataTestimoni.komentar);
      formData.append("image", formDataTestimoni.image);

      const response = await fetch(`${process.env.REACT_APP_BASE_URL}api/testimoni/insert`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {

        // Reset form
        setFormDataTestimoni({
          nama: "",
          sumber: "",
          komentar: "",
          image: "",
        });

        setAddTestimoni(null);
        await fetchTestimoni();
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Testimoni berhasil ditambahkan!",
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        alert(result.message || "Gagal menyimpan data");
      }
    } catch (error) {
      console.error(error);
      alert("Terjadi kesalahan");
    }
  };
  
  const handleDelete = (id) => {
    Swal.fire({
      title: 'Yakin hapus Testimoni ini?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Ya, hapus',
      cancelButtonText: 'Batal',
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${process.env.REACT_APP_BASE_URL}api/testimoni/${id}`, {
          method: 'DELETE',
        })
          .then((res) => res.json())
          .then(() => {
            Swal.fire('Terhapus!', 'Testimoni berhasil dihapus.', 'success');
            fetchTestimoni();
          });
      }
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("nama", formDataTestimoni.nama);
      formData.append("sumber", formDataTestimoni.sumber);
      formData.append("komentar", formDataTestimoni.komentar);

      // hanya kirim icon jika ada file baru
      if (formDataTestimoni.image) {
        formData.append("image", formDataTestimoni.image);
      }

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/testimoni/${editId}`,
        {
          method: "POST", // CI4 biasanya POST untuk update
          body: formData,
        }
      );

      const result = await response.json();

      if (response.ok) {

        await fetchTestimoni(); // refresh data
        
        setAddTestimoni(null);
        await fetchTestimoni();
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Testimoni berhasil diupdate!",
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        alert(result.message || "Gagal update");
      }
    } catch (error) {
      console.error(error);
      alert("Terjadi kesalahan");
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white pt-20">
      {/* Header Section */}
      <section 
        data-section="header"
        className="py-24 bg-gradient-to-b from-slate-900 to-slate-950 relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <img
            src="/images/bg-hero-about-us.jpeg"
            alt="background"
            className="w-full h-full object-cover opacity-20"
          />
        </div>

        <div className={`relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 opacity-100 translate-y-0
        }`}>
          <h1 className="font-bricolage text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-red-400 bg-clip-text text-transparent">
            Halaman Admin
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-red-500 mx-auto mb-6"></div>
        </div>
      </section>
      <section 
        data-section="contact"
        className="py-24 bg-slate-950"
      >
        <div className='flex flex-row max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-200'>
          <div className='w-1/4'>
            <Sidebar></Sidebar>
          </div>
          <div className='w-3/4 p-4 bg-gray-800 text-white flex-col md:relative md:flex rounded-3xl '>
            <div className='flex flex-col'>
              <div className='p-4 text-xl font-medium'>
                List Komentar Radar Pulsa
              </div>
              <div className='flex flex-row p-4'>
                <table class="min-w-full divide-y divide-gray-200 bg-gradient-to-b from-slate-900 to-slate-950 text-gray-400">
                  <thead class="font-bricolage font-bold mb-4 bg-gradient-to-r from-blue-400 to-red-400  text-transparent">
                    <tr>
                      <th class="p-4 font-medium text-gray-900 text-center">Nama</th>
                      <th class="p-4 font-medium text-gray-900 text-center">Sumber</th>
                      <th class="p-4 font-medium text-gray-900 text-center">Komentar</th>
                      <th class="font-medium text-gray-900 text-center">Image</th>
                      <th class="font-medium text-gray-900 text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-200">
                    {Array.isArray(testimoni) && testimoni.map((a, idx) => (
                      <>
                        <tr class="hover:bg-gray-500">
                          <td class="p-4  text-white text-center">{a.nama}</td>
                          <td class="p-4 text-white text-center">{a.sumber}</td>
                          <td class="p-4 text-white text-center">{a.komentar}</td>
                          <td class="p-4 text-white text-center">
                            <img className='max-h-80' src={`${process.env.REACT_APP_BASE_URL}uploads/images/${a.image}`} />
                          </td>
                          <td class="p-4 text-white text-center">
                            <div className='flex flex-row gap-4 items-center justify-center'>
                              <FaPencil onClick={() => handleEditClick(a)} className='cursor-pointer'></FaPencil> 
                              <FaTrash onClick={() => handleDelete(a.id)} className='cursor-pointer'></FaTrash>
                            </div>
                          </td>
                        </tr>
                      </>
                      ))
                    }
                  </tbody>
                </table>
              </div>
              <div className='flex flex-row'>
                <div className='w-1/3 p-4'>
                  <button onClick={handleAdd} className='p-4 rounded-full bg-gradient-to-r from-blue-600/30 to-red-600/30 hover:shadow-xl hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300'>Tambah</button>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </section>
      {addTestimoni && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50 p-4"
          onClick={() => {
            setAddTestimoni(null);
            setEditId(null);
          }}
        >
          <div
            className="bg-white text-black p-6 rounded-2xl w-full max-w-md relative shadow-2xl max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              className="absolute top-3 right-3 text-gray-500 hover:text-red-500 transition"
              onClick={() => {
                setAddTestimoni(null);
                setEditId(null);
              }}
            >
              <X size={20} />
            </button>

            {/* Title */}
            <h3 className="text-xl font-bold mb-6 text-center">
              {editId
                ? "Edit Komentar Radar Pulsa"
                : "Tambah Komentar Radar Pulsa"}
            </h3>

            {/* Form */}
            <form
              onSubmit={editId ? handleUpdate : handleInsert}
              className="space-y-4"
            >
              {/* Title */}
              <div>
                <label className="block font-medium mb-1">Nama</label>
                <input
                  type="text"
                  value={formDataTestimoni.nama}
                  onChange={(e) =>
                    setFormDataTestimoni({
                      ...formDataTestimoni,
                      nama: e.target.value,
                    })
                  }
                  className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                  required
                />
              </div>

              <div>
                <label className="block font-medium mb-1">Sumber</label>
                <input
                  type="text"
                  value={formDataTestimoni.sumber}
                  onChange={(e) =>
                    setFormDataTestimoni({
                      ...formDataTestimoni,
                      sumber: e.target.value,
                    })
                  }
                  className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                  required
                />
              </div>

              {/* Description */}
              <div>
                <label className="block font-medium mb-1">Komentar</label>
                <textarea
                  rows="3"
                  value={formDataTestimoni.komentar}
                  onChange={(e) =>
                    setFormDataTestimoni({
                      ...formDataTestimoni,
                      komentar: e.target.value,
                    })
                  }
                  className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                />
              </div>

              {/* Icon Upload */}
              <div>
                <label className="block font-medium mb-1">Image</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    setFormDataTestimoni({
                      ...formDataTestimoni,
                      image: e.target.files[0],
                    })
                  }
                  className="w-full border border-gray-300 p-2 rounded-lg"
                />
                
                <span className='text-sm text-red-600'><i>*rekomendasi file type: .png, .jpg, .jpeg</i></span>

                {/* Preview Image */}
                {formDataTestimoni.image && (
                  <img
                    src={URL.createObjectURL(formDataTestimoni.image)}
                    alt="preview"
                    className="mt-3 h-20 object-contain rounded-lg border"
                  />
                )}
              </div>

              {/* Buttons */}
              <div className="flex justify-end gap-3 pt-4">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-200 rounded-full hover:bg-gray-300 transition"
                  onClick={() => {
                    setAddTestimoni(null);
                    setEditId(null);
                  }}
                >
                  Batal
                </button>

                <button
                  type="submit"
                  className="px-6 py-2 rounded-full bg-gradient-to-r from-blue-600 to-red-600 text-white hover:shadow-lg transform hover:scale-105 transition-all duration-300"
                >
                  {editId ? "Update" : "Simpan"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Testimoni;
